import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../services/api'
import { useAuth } from '../../context/AuthContext'
import { useToast } from '../../context/ToastContext'
import LoadingSpinner from '../../components/LoadingSpinner'

const AdminLogin = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { login } = useAuth()
  const { addToast } = useToast()

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await apiClient.post('/api/auth/login', { username, password })
      login(response.data.token)
      navigate('/admin')
    } catch (err) {
      const message = err.response?.data?.message || 'Login failed'
      setError(message)
      addToast(message, 'danger')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container py-5 admin-login-page">
      <div className="card border-0 shadow-sm p-4 p-lg-5 mx-auto" style={{ maxWidth: 460 }}>
        <h2>Admin Login</h2>
        <p className="text-muted mb-4">Sign in to manage appointments, website content, and clinic settings.</p>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-12">
            <label className="form-label">Username</label>
            <input
              className="form-control"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
            />
          </div>
          <div className="col-12">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>
          <div className="col-12">
            <button className="btn btn-primary w-100" type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
      {loading && <LoadingSpinner size="2rem" />}
    </div>
  )
}

export default AdminLogin
